// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ingredient-details_infoWrapper__15raj","proteinWrapper":"ingredient-details_proteinWrapper__3ig2c","li":"ingredient-details_li__1B6hz"};